import type { TaskAnswerOptionType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';

interface TaskAnswerOptionsProps {
    answers: TaskAnswerOptionType[];
    value: number | null;
    name: string;
    readOnly?: boolean;
    disabled?: boolean;
    onChange?: (key: number) => void;
}

const optionClassName = (checked: boolean): string =>
    `d-flex align-items-center gap-3 border rounded px-3 py-2 mb-2 ${checked ? 'border-primary' : ''}`;

const TaskAnswerOptions = ({
    answers,
    value,
    name,
    readOnly = false,
    disabled = false,
    onChange,
}: TaskAnswerOptionsProps) => (
    <div>
        {answers.map((item, index) => {
            const checked = value === item.key;
            const mark = (
                <>
                    <span
                        className={`d-inline-flex align-items-center justify-content-center rounded fw-medium ${
                            checked ? 'bg-primary text-white' : 'bg-light text-muted'
                        }`}
                        style={{ width: 32, height: 32, flex: '0 0 32px' }}
                    >
                        {index + 1}
                    </span>
                    <span className={`flex-grow-1 ${checked ? 'fw-medium text-body' : 'text-body'}`}>{item.text}</span>
                    <SolarIcon
                        name={checked ? 'check-circle-fill' : 'check-circle'}
                        className={checked ? 'text-primary' : 'text-muted'}
                    />
                </>
            );

            if (readOnly) {
                return (
                    <div key={item.key} className={optionClassName(checked)}>
                        {mark}
                    </div>
                );
            }

            return (
                <label key={item.key} className={`${optionClassName(checked)} ${disabled ? '' : 'cursor-pointer'}`}>
                    <input
                        type="radio"
                        className="visually-hidden"
                        name={name}
                        value={item.key}
                        checked={checked}
                        disabled={disabled}
                        onChange={() => onChange?.(item.key)}
                    />
                    {mark}
                </label>
            );
        })}
    </div>
);

export default TaskAnswerOptions;
